(function () {
  'use strict';

  function injectDragStyles() {
    if (document.getElementById('ac-img-slider-drag-style')) return;

    var style = document.createElement('style');
    style.id = 'ac-img-slider-drag-style';
    style.textContent = [
      '.ac-img-slider[data-ac-slider]{cursor:grab;touch-action:pan-y;user-select:none;}',
      '.ac-img-slider.ac-slider-dragging{cursor:grabbing;}',
      '.ac-img-slider__dots{display:none!important;}',
      '.ac-img-slider[data-ac-slider] *{-webkit-user-drag:none;}'
    ].join('');
    document.head.appendChild(style);
  }

  function initSlider(slider) {
    if (slider._acInit) return;
    slider._acInit = true;

    var srcs;
    try { srcs = JSON.parse(slider.getAttribute('data-srcs') || '[]'); } catch (_) { srcs = []; }
    if (srcs.length <= 1) return;

    var primaryImg = slider.querySelector('.ac-primary-img');
    var hoverImg   = slider.querySelector('.ac-hover-img');
    var dots       = slider.querySelectorAll('[data-ac-dot]');
    var prevBtn    = slider.querySelector('[data-ac-prev]');
    var nextBtn    = slider.querySelector('[data-ac-next]');
    var link       = slider.querySelector('[data-ac-product-link]');
    var cardMedia  = slider.closest('.card-media');
    var total      = srcs.length;
    var current    = 0;
    var swapTimer  = null;
    var selfSwapping = false;
    var userNavigated = false;

    function setDots(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    function buildSrcset(url533) {
      var sizes = [165, 320, 533, 720, 1066];
      return sizes.map(function (w) {
        return url533.replace(/_533x(\.\w+)(\?|$)/, '_' + w + 'x$1$2') + ' ' + w + 'w';
      }).join(', ');
    }

    function setPrimaryImg(url) {
      if (!primaryImg) return;
      selfSwapping = true;
      primaryImg.classList.remove('lazyload', 'lazyloaded', 'lazyloading');
      primaryImg.setAttribute('srcset', buildSrcset(url));
      primaryImg.setAttribute('src', url);
      setTimeout(function () { selfSwapping = false; }, 100);
    }

    function enterManualMode() {
      userNavigated = true;
      slider.classList.add('ac-slider-manual');
      if (hoverImg) {
        hoverImg.classList.remove('ac-hover-forced');
        hoverImg.classList.add('ac-hover-suppressed');
      }
    }

    function restoreHoverMode() {
      userNavigated = false;
      current = 0;
      slider.classList.remove('ac-slider-manual', 'ac-slider-dragging');
      setPrimaryImg(srcs[0]);
      if (hoverImg) {
        hoverImg.classList.remove('ac-hover-forced', 'ac-hover-suppressed');
      }
      setDots(0);
    }

    function showImage(idx) {
      idx = ((idx % total) + total) % total;
      current = idx;
      enterManualMode();
      setPrimaryImg(srcs[idx]);
      setDots(idx);
    }

    if (cardMedia) {
      cardMedia.addEventListener('mouseleave', function () {
        if (!userNavigated) return;
        setTimeout(restoreHoverMode, 80);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); showImage(current - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); showImage(current + 1);
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) { e.stopPropagation(); showImage(i); });
    });

    var pStartX = 0;
    var pStartY = 0;
    var pDeltaX = 0;
    var pActive = false;
    var wasSwiped = false;
    var activePointerId = null;
    var THRESHOLD = 26;

    function isControl(target) {
      return !!(target && target.closest && target.closest('[data-ac-prev], [data-ac-next], [data-ac-dot]'));
    }

    function endDrag(e) {
      if (!pActive) return;
      pActive = false;
      slider.classList.remove('ac-slider-dragging');

      if (activePointerId !== null) {
        try { slider.releasePointerCapture(activePointerId); } catch (_) {}
      }
      activePointerId = null;

      if (wasSwiped && Math.abs(pDeltaX) >= THRESHOLD) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        showImage(pDeltaX < 0 ? current + 1 : current - 1);
      }
    }

    slider.addEventListener('pointerdown', function (e) {
      if (isControl(e.target)) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pStartX = e.clientX;
      pStartY = e.clientY;
      pDeltaX = 0;
      pActive = true;
      wasSwiped = false;
      activePointerId = e.pointerId;
      slider.classList.add('ac-slider-dragging');
      try { slider.setPointerCapture(e.pointerId); } catch (_) {}
    });

    slider.addEventListener('pointermove', function (e) {
      if (!pActive) return;
      pDeltaX = e.clientX - pStartX;
      var deltaY = e.clientY - pStartY;

      if (Math.abs(pDeltaX) > THRESHOLD && Math.abs(pDeltaX) > Math.abs(deltaY)) {
        wasSwiped = true;
        e.preventDefault();
      }
    }, { passive: false });

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', function () {
      pActive = false;
      wasSwiped = false;
      activePointerId = null;
      slider.classList.remove('ac-slider-dragging');
    });

    slider.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    slider.addEventListener('click', function (e) {
      if (wasSwiped && Math.abs(pDeltaX) >= THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
        wasSwiped = false;
        pDeltaX = 0;
        return;
      }

      if (link && !isControl(e.target)) {
        e.preventDefault();
        e.stopPropagation();

        if (e.metaKey || e.ctrlKey) {
          window.open(link.href, '_blank');
        } else {
          window.location.href = link.href;
        }
        return;
      }

      wasSwiped = false;
      pDeltaX = 0;
    }, true);

    if (primaryImg && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        if (selfSwapping) return;
        clearTimeout(swapTimer);
        swapTimer = setTimeout(function () {
          var cur = primaryImg.getAttribute('srcset') || primaryImg.getAttribute('src') || '';
          var firstSrc = cur.split(',')[0].trim().split(' ')[0];
          var curFile = firstSrc.split('/').pop().split('?')[0]
            .replace(/_\d+x(\.\w+)?$/, '').toLowerCase();
          var curSrcFile = (srcs[current] || '').split('/').pop().split('?')[0]
            .replace(/_\d+x(\.\w+)?$/, '').toLowerCase();
          if (curFile === curSrcFile) return;
          srcs.forEach(function (s, i) {
            var file = s.split('/').pop().split('?')[0].replace(/_\d+x(\.\w+)?$/, '').toLowerCase();
            if (file === curFile) { current = i; setDots(i); }
          });
        }, 50);
      }).observe(primaryImg, { attributes: true, attributeFilter: ['src', 'srcset'] });
    }
  }

  function initAll() {
    injectDragStyles();
    document.querySelectorAll('[data-ac-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  setInterval(function () {
    document.querySelectorAll('[data-ac-slider]').forEach(function (s) {
      if (!s._acInit) initSlider(s);
    });
  }, 300);

  new MutationObserver(function (m) {
    var found = false;
    m.forEach(function (r) { if (r.addedNodes.length) found = true; });
    if (found) initAll();
  }).observe(document.body, { childList: true, subtree: true });
})();
